import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginContext } from '../../reactcontext/ReactContext';
import axios from 'axios';
import SupportTicketList from './SupportTicketList';
import CreateTicketForm from './CreateTicketForm';

const Support = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { loginInfo } = useContext(LoginContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('my-tickets');
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    !loginInfo.login && navigate('/');
  }, [loginInfo]);

  const fetchTickets = async () => {
    try {
      const response = await axios.get(`${apiUrl}/support`, {
        headers: {
          loginToken: localStorage.getItem('loginToken'),
        },
      });
      setTickets(response.data.tickets);
    } catch (error) {
      console.error('Error fetching tickets:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const handleTicketCreated = () => {
    fetchTickets();
    setActiveTab('my-tickets');
  };

  const isAdmin = loginInfo.userDetails?.role?.toLowerCase() === 'admin';

  return (
    <div className='w-full flex h-full flex-col items-center justify-between relative gap-3'>
      <div className='self-start'>
        <Link to={'/dashboard'} className='text-yellow-700'>
          Dashboard
        </Link>
        {' > Support'}
      </div>

      <div className='w-full max-w-6xl'>
        <h1 className='text-2xl font-bold mb-6'>Support Center</h1>

        <div className='flex gap-4 mb-6'>
          <button
            onClick={() => setActiveTab('my-tickets')}
            className={`px-4 py-2 rounded ${
              activeTab === 'my-tickets'
                ? 'bg-yellow-500 text-white'
                : 'bg-gray-200 text-gray-700'
            }`}
          >
            My Tickets
          </button>
          <button
            onClick={() => setActiveTab('create-ticket')}
            className={`px-4 py-2 rounded ${
              activeTab === 'create-ticket'
                ? 'bg-yellow-500 text-white'
                : 'bg-gray-200 text-gray-700'
            }`}
          >
            Create Ticket
          </button>
          {isAdmin && (
            <button
              onClick={() => setActiveTab('manage-tickets')}
              className={`px-4 py-2 rounded ${
                activeTab === 'manage-tickets'
                  ? 'bg-yellow-500 text-white'
                  : 'bg-gray-200 text-gray-700'
              }`}
            >
              Manage All Tickets
            </button>
          )}
        </div>

        {activeTab === 'my-tickets' && (
          <SupportTicketList
            tickets={tickets.filter(ticket =>
              !isAdmin ? ticket.createdBy === loginInfo.userDetails.id : true
            )}
            loading={loading}
            isAdmin={isAdmin}
            onUpdate={fetchTickets}
          />
        )}

        {activeTab === 'create-ticket' && (
          <CreateTicketForm onTicketCreated={handleTicketCreated} />
        )}

        {activeTab === 'manage-tickets' && isAdmin && (
          <SupportTicketList
            tickets={tickets}
            loading={loading}
            isAdmin={true}
            onUpdate={fetchTickets}
          />
        )}
      </div>
    </div>
  );
};

export default Support;